import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";
import { useToast } from "../../controller/ToastController";
import ApiController from "../../controller/ApiController";
import { formatTime, sendInterval } from "../../utils/util";
import { qrAuthState, qrAuthType } from "../../recoil/auth";

let timer: any = null;

const AuthenticationModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  onAuthenticate: any;
}) => {
  const [auth, setAuth] = useRecoilState<qrAuthType>(qrAuthState);

  const showToast = useToast();
  const lang = useRecoilValue(langState);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [authCode, setAuthCode] = useState<string>("");
  const [countdown, setCountdown] = useState<number>(0);

  // 인증번호 전송
  const sendSMSCode = async () => {
    if (timer === null) {
      if (phoneNumber.length < 10 || phoneNumber.length > 11) {
        showToast("올바른 번호를 입력해주세요.", "error");
      } else {
        const res = await ApiController.user.sendSms(phoneNumber);
        if (res.data.success) {
          showToast("인증번호를 전송했어요.");
          timer = sendInterval(180, setCountdown, () => {
            clearInterval(timer);
            timer = null;
          });
        } else {
          showToast("인증번호가 이미 발송되었어요.", "error");
        }
      }
    } else {
      showToast("인증번호가 이미 발송되었어요.", "error");
    }
  };

  // 인증번호 확인
  const verifySMSCode = async () => {
    if (timer !== null) {
      const res = await ApiController.user.verifySmsAndRegisterUser(authCode);
      console.log("res", res);
      if (res && res.data.success) {
        showToast("인증을 성공했어요.");
        clearInterval(timer);
        setCountdown(0);
        setAuth({ ...auth, phone_number: phoneNumber });
        await AsyncLocalStorage.setItem(
          "qrAuth",
          JSON.stringify({ ...auth, phone_number: phoneNumber })
        );
        oProps.onAuthenticate();
      } else {
        showToast("인증번호를 확인해주세요.", "error");
      }
    } else console.log("인증 오류");
  };

  const onChangePhoneNumber = (e: any) => {
    setPhoneNumber(e.target.value);
  };
  const onChangeCheckNumber = (e: any) => {
    setAuthCode(e.target.value);
  };

  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  useEffect(() => {
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (!oProps.isVisible) {
      clearInterval(timer);
    }
  }, [oProps.isVisible]);

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="languageModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <h6>{langText.authenticationModal_title[lang]}</h6>
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="ic"
            />
          </div>
          <div className="modal_content">
            <h5>{langText.authenticationModal_phone_number[lang]}</h5>
            <div className="inputWrap">
              <input
                value={phoneNumber}
                placeholder={
                  langText.authenticationModal_placeholder_phone_number[lang]
                }
                onChange={onChangePhoneNumber}
              />
              <button onClick={sendSMSCode}>
                <h5>{langText.authenticationModal_button_receieve[lang]}</h5>
              </button>
            </div>
            <h5>{langText.authenticationModal_verity_code[lang]}</h5>
            <div className="inputWrap">
              <input
                value={authCode}
                placeholder={
                  langText.authenticationModal_placeholder_code[lang]
                }
                onChange={onChangeCheckNumber}
                maxLength={6}
              />
              <p>{formatTime(countdown)}</p>
            </div>
          </div>
          <button className="submitButton" onClick={verifySMSCode}>
            {langText.authenticationModal_button_complete[lang]}
          </button>
        </div>
      </Style>
    </Modal>
  );
};

export default AuthenticationModal;

const Style = styled.div`
  .modal {
    padding: 24px 10px;
    padding-bottom: 40px;
    position: relative;
  }

  .modal_header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    h6 {
      font-size: 20px;
      line-height: 30px;
      font-weight: 500;
      color: #ffffff;
    }
    .closeIcon {
      position: absolute;
      width: 24px;
      right: 12px;
      top: 12px;
    }
  }
  .modal_content {
    padding-top: 20px;
    width: 100%;

    h5 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
      margin-bottom: 4px;
    }
    input {
      width: 100%;
      padding: 10px 14px;
      background: #343434;
      border: 1px solid #a7a7a7;
      border-radius: 5px;
      font-size: 14px;
      line-height: 18px;
      color: #ffffff;
      margin-bottom: 20px;
      outline-color: #4dd2ae;
    }
    .inputWrap {
      position: relative;
      button {
        position: absolute;
        right: 0;
        background: #343434;
        padding: 8px 6px;
        border-radius: 5px;
        border: 1px solid #4dd2ae;
        h5 {
          font-size: 14px;
          color: #4dd2ae;
          margin: 0;
        }
      }
      p {
        position: absolute;
        top: 12px;
        right: 16px;
        font-size: 14px;
        line-height: 14px;
        font-weight: 600;
        color: #ff4a4a;
      }
    }
  }
  .submitButton {
    width: 100%;
    padding: 12px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 20px;
    line-height: 30px;
    font-weight: 600;
  }
`;
